module.exports = __webpack_public_path__ + "img/Nicaragua.535aca50.png";